const ko = {
	'快跟我一起来<br />SuperChinese学中文吧!': '나랑 같이 SuperChinese<br />에서 중국어 배우자!',
	'零基础任性学': '왕초보도 마음껏 학습 가능',
	'听说读写全面提升': '듣기, 말하기, 읽기, 쓰기 향상',
	'趣味对话': '재미있는 대화',
	'100+日常对话等你来': '100+일상 대화 포함',
	'智能AI': '지능 AI',
	'个性化学习推荐，由浅入深系统学': '맞춤형 방안으로 체계적으로 학습',
	'趣味对话等你来': '재미있는 대화로 배웁시다',
	'立即打开': '바로 열기',
	'我在SuperChinese<br />已累计学习{day}天': '회원님께서는 SuperChinese<br />에서 총 <span>{day}</span> 일 공부하셨습니다.',
	'我在SuperChinese<br />已连续学习{day}天': '회원님께서는 SuperChinese<br />에서 이미 연속 <span>{day}</span> 일 공부하셨습니다.',
	'学习生词': '학습한 어휘수',
	'学习语法': '학습한 문법 항목수',
	'口语练习': '말하기 연습',
	'{n}个': '<span>{n}</span>개',
	'{n}次': '<span>{n}</span>번',
	'点击右上角的按钮,选择在浏览器中打开': '오른쪽 위의 버튼을 클릭하세요,브라우저에서 열기를 선택하세요',
	'邀请码': '초대 코드',
	'用邀请码注册，参与抽大奖': '신규 사용자가 등록하고 초대 코드를 입력하면 추첨에 참여할 수 있습니다.',
}
export default ko;